import Cookies from 'js-cookie'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    firstName: null,
    lastName: null,
    disclaimerAccepted: Cookies.get('disclaimerAccepted') || false
  },
  getters: {
    disclaimerAccepted: state => state.disclaimerAccepted,
    name(state) {
      if (state.firstName && state.lastName) {
        return state.firstName + ' ' + state.lastName
      } else if (state.firstName && !state.lastName) {
        return state.firstName
      } else if (!state.firstName && state.lastName) {
        return state.lastName
      } else {
        return null
      }
    }
  },
  mutations: {
    login(index) {
      index.isAuthenticated = true
    },
    logout(state) {
      state.isAuthenticated = false
    },
    disclaimerAccepted(state) {
      state.disclaimerAccepted = true
      Cookies.set('disclaimerAccepted', true)
    },
    name(state, payload) {
      state.firstName = payload.first
      state.lastName = payload.last
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js